import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_inventory_count_tasks_progress_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { inventoryCountId: number, $top?: number, $skip?: number }): Promise<{ result?: { StatusName?: string, Count?: number }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.inventoryCountId)) {
      $missingRequiredInParams.push('\'inventoryCountId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      inventoryCountId: number    }) {
        if(isNil($inParams.inventoryCountId)) {
          return true; 
        }
      return false;
    }
}
